var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSquare123AError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 143 69",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M137.761 1.22a3.052 3.052 0 0 1 3.051 3.051v61.88l-8.849.885A3.052 3.052 0 0 1 128.608 64V16.474a3.05 3.05 0 0 0-3.05-3.05H16.475a3.051 3.051 0 0 0-3.051 3.051v47.526a3.052 3.052 0 0 1-3.355 3.037l-8.848-.885V4.272a3.052 3.052 0 0 1 3.05-3.05h28.114V1.22H137.76Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  d: "M137.761 0a4.271 4.271 0 0 1 4.271 4.27v62.542a1.221 1.221 0 0 1-2.441 0l.001-62.541c0-1.011-.82-1.83-1.831-1.83H4.271c-1.01 0-1.83.819-1.83 1.83v62.541a1.22 1.22 0 1 1-2.441 0V4.272A4.271 4.271 0 0 1 4.271 0h133.49Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2,
  d: "M27.5 25.878h23a1.5 1.5 0 0 1 1.5 1.5v23a1.5 1.5 0 0 1-1.5 1.5h-23a1.5 1.5 0 0 1-1.5-1.5v-23a1.5 1.5 0 0 1 1.5-1.5ZM91.5 25.878h23a1.5 1.5 0 0 1 1.5 1.5v23a1.5 1.5 0 0 1-1.5 1.5h-23a1.5 1.5 0 0 1-1.5-1.5v-23a1.5 1.5 0 0 1 1.5-1.5Z"
})));
SvgSquare123AError.viewBox = '0 0 143 69';
const ForwardRef = /*#__PURE__*/forwardRef(SvgSquare123AError);
export default ForwardRef;